
import { Component, EventEmitter, Output } from '@angular/core';

const FAQ_MOCK = [
  {
    order: 1,
    question: 'O que é o Gerenciamento de Portfólio?',
    answer:
      '<p>O Gerenciamento de Portfólio é uma ferramenta online que permite analisar, monitorar e controlar informações de Pessoas Físicas (via CPF) e Pessoas Jurídicas (via CNPJ). Ele auxilia você a entender a situação financeira e comercial de seus clientes e potenciais clientes, facilitando o planejamento de ações e o gerenciamento de risco da sua carteira.</p>',
  },
  {
    order: 2,
    question: 'O que é um "documento" no Gerenciamento de Portfólio? ',
    answer:
      '<p>No Gerenciamento de Portfólio, um "documento" é o registro de um cliente que você deseja monitorar. Ele pode ser um CPF, para Pessoas Físicas, ou um CNPJ, para Pessoas Jurídicas. Você pode gerenciar seus documentos na seção "Documentos" no menu lateral da plataforma.</p>',
  },
  {
    order: 3,
    question: 'Quais informações complementares um "documento" pode ter?',
    answer:
      '<p>Além da identificação (CPF/CNPJ) e do nome/razão social, um documento pode conter:</p><ul class="list-question"><li><b>Tempo de Acompanhamento:</b> Período definido para o monitoramento do documento (ex: 3 meses, 6 meses, ou por tempo indeterminado).</li><li><b>Código Interno:</b> Um código de sua preferência para identificação interna do cliente em seus sistemas.</li><li><b>Segmento:</b> Classificação de segmento de mercado do cliente, conforme seus critérios.</li></ul><p>Estas informações ajudam a organizar e filtrar sua base de documentos monitorados.</p>',
  },
  {
    order: 4,
    question: 'O que é uma "carteira"? ',
    answer:
      '<p>Uma "carteira" é um agrupamento personalizável de documentos (CPFs/CNPJs) que você deseja monitorar em conjunto. Isso permite organizar seus clientes de acordo com critérios relevantes para o seu negócio. A gestão das carteiras é feita na seção "Carteiras" no menu lateral. Nele é possível criar carteiras para monitoramento.</p>',
  },
  {
    order: 5,
    question: 'Como começo a usar o Gerenciamento de Portfólio?',
    answer:
      '<p>Para iniciar, acesse a plataforma, inclua os documentos (CPFs/CNPJs) dos clientes que deseja acompanhar e, se desejar, organize-os em carteiras específicas. A inclusão de documentos pode ser feita individualmente ou de forma massiva através de upload de planilha.</p>',
  },
  {
    order: 6,
    question: 'Quais atributos posso monitorar nos documentos?',
    answer:
      '<p>Você pode monitorar diversos atributos. Para o plano básico, os principais atributos disponíveis são:</p><ul class="list-question"><li><b>Para Pessoa Jurídica (documento CNPJ):</b> Score, Ações cíveis, Falências, Negativações e Protestos.</li><li><b>Para Pessoa Física (documento CPF):</b> Score, Ações cíveis, Negativações e Protestos.</li></ul>',
  },
  {
    order: 7,
    question: 'O que são os alertas e como eles funcionam? ',
    answer:
      '<p>Alertas são notificações automáticas sobre mudanças relevantes nos atributos monitorados dos seus documentos. Por exemplo, você pode ser alertado se houver alteração no score de um cliente ou se uma nova negativação for registrada. Você define, na seção "Carteiras", para quais atributos deseja receber alertas e o e-mail para notificação.</p>',
  },
  {
    order: 8,
    question: 'Como recebo os alertas? ',
    answer:
      '<p>Os alertas sobre alterações nos atributos monitorados são enviados para o e-mail que você cadastrou e também podem ser visualizados diretamente na plataforma, na seção "Painel". O e-mail de alerta informa o nome da carteira, a data da variação e quais atributos sofreram alterações.</p>',
  },
  {
    order: 9,
    question: 'Como visualizo os detalhes das alterações na plataforma? ',
    answer:
      '<p>No "Painel" (acessível pelo menu lateral), a seção "Resumo dos Indicadores" de uma carteira apresenta um sumário das variações (documentos sem variação, com variação positiva ou com variação negativa). Para detalhes específicos por documento e atributo, o Painel oferece uma visão comparativa, mostrando o valor atual, o valor anterior e a natureza da variação, permitindo que você entenda exatamente o que mudou.</p>',
  },
  {
    order: 10,
    question: 'Com que frequência os dados dos atributos são atualizados? ',
    answer:
      '<p>A atualização dos dados e atributos dos documentos monitorados ocorre diariamente, com exceção do Score que é semanalmente.</p>',
  },
  {
    order: 11,
    question:
      'Como o Nome (Pessoa Física) ou Razão Social (Pessoa Jurídica) de um documento é preenchido? ',
    answer:
      '<p>Ao incluir um novo documento para monitoramento, o nome da pessoa ou a razão social da empresa é automaticamente preenchido com base nas informações da nossa base de dados (EBV). Essa atualização ocorre após a inclusão, durante o horário comercial, em até 1 hora.</p>',
  },
  {
    order: 12,
    question: 'Quando os atributos de um novo documento são atualizados pela primeira vez? ',
    answer:
      '<p>Após a inclusão de um novo documento, as informações dos atributos monitorados (como Score, Quantidade de Negativações, etc.) são carregadas e atualizadas na plataforma, durante o horário comercial, em até 1 hora.</p>',
  },
  {
    order: 13,
    question: 'Como funciona o monitoramento contínuo dos atributos de um documento? ',
    answer:
      '<p>Após a inclusão e a primeira carga de dados, os documentos ativos para monitoramento (conforme o "Tempo de Acompanhamento") têm seus atributos verificados semanalmente. Caso ocorra alguma alteração (positiva ou negativa) nos atributos que você configurou para alerta, uma notificação será gerada.</p>',
  },
  {
    order: 14,
    question: 'O que são "Favoritos"? ',
    answer:
      '<p>A funcionalidade "Favoritos" permite que você marque Documentos e Carteiras para acessá-los de forma mais rápida e direta dentro da plataforma, facilitando a gestão dos itens mais importantes para você.</p>',
  },
  {
    order: 15,
    question: 'Como faço a exportação de documentos? ',
    answer:
      '<p>Na seção "Documentos" do menu lateral, você pode gerar e baixar um relatório em formato de planilha (.xlsx) contendo a lista dos seus documentos monitorados e suas informações.</p>',
  },
  {
    order: 16,
    question: 'Como funciona a "Carga Massiva" de documentos? ',
    answer:
      '<p>A "Carga Massiva" permite incluir múltiplos documentos na plataforma de uma só vez, utilizando o upload de uma planilha no formato .xlsx. Um modelo (template) da planilha e as instruções de preenchimento estão disponíveis na própria funcionalidade. Na seção "Arquivos Processados" (no menu lateral), você pode acompanhar o status dos seus uploads e fazer o download dos arquivos de retorno com os resultados do processamento.</p>',
  },
  {
    order: 17,
    question: 'Como funciona a cobrança do Gerenciamento de Portfólio? ',
    answer:
      '<p>A cobrança pelo uso do Gerenciamento de Portfólio é baseada no plano contratado e considera os seguintes pontos:</p><ul class="list-question"><li>Um valor por cada documento (CPF ou CNPJ) ativo e monitorado.</li><li>Um período de fidelidade de 90 dias para o monitoramento de cada documento incluído na plataforma.</li></ul>',
  },
];

@Component({
  selector: 'app-frequent-question',
  templateUrl: './frequent-question.component.html',
  styleUrls: ['./frequent-question.component.scss'],
  imports: [],
})
export class FrequentQuestionComponent {
  selected: number = 1;
  userCountry: string | null = localStorage.getItem('userCountry');

  @Output()
  finishLoading = new EventEmitter();

  public dataFrequentQuestion = FAQ_MOCK;

  select(orderQuestion: number) {
    this.selected = orderQuestion;
  }

  isSelected(orderQuestion: number) {
    if (orderQuestion === this.selected) {
      return true;
    } else {
      return false;
    }
  }
}
